import React from "react";
import AllBanner from "../component/sections/advertise/banner/AllBanner";
import AddBanner from "../component/sections/advertise/banner/AddBanner";
import EditBanner from "../component/sections/advertise/banner/EditBanner";
import SelectBannerGenerator from "../component/sections/advertise/banner-generator/SelectBannerGenerator";

const advertiseRoutes = [
  {
    path: "/advertise/banner/all",
    render: () => <AllBanner />,
    exact: true,
  },
  {
    path: "/advertise/banner/add/:id",
    render: () => <AddBanner />,
    exact: true,
  },
  {
    path: "/advertise/banner/edit/:id",
    render: () => <EditBanner />,
    exact: true,
  },
  {
    path: "/advertise/banner-generator",
    render: () => <SelectBannerGenerator />,
    exact: true,
  },
];

export default advertiseRoutes;
